module.exports = __webpack_public_path__ + "static/media/play.cb750aef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/play.svg
// module id = 168
// module chunks = 0